import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { FRESHDESK_STATUSES, updateTicket } from '../../../actions/freshdesk-actions';
import PropTypes from 'prop-types';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { TEN_MINUTES_IN_MILLISECONDS } from '../../../utils/dates-const';
import CloseTicketPopup from './CloseTicketPopup';

const TicketBody = ({ ticket, classes, updateTicket }) => {
  const { id, description, created_at } = ticket;
  const [content, setContent] = useState(null);
  const [editTicketId, setEditTicketId] = useState(null);
  const [closePopup, setClosePopup] = useState(false);
  const [closePopupId, setClosePopupId] = useState(null);
  const isEditing = editTicketId === id;
  const [animation] = useAutoAnimate();
  const isOpen = ticket.status === FRESHDESK_STATUSES.OPEN.code;
  
  const closeTicket = (ticketId) => {
    setClosePopup(true);
    setClosePopupId(ticketId);
  };
  
  const enableEdit = (ticketId) => {
    setEditTicketId(ticketId);
  };
  
  const saveFunction = (id, content) => {
    updateTicket(id, content).then(() => setEditTicketId(null));
  };
  
  const isEditVisible = (dateTime) => new Date() - new Date(dateTime) <= TEN_MINUTES_IN_MILLISECONDS;
  
  return (
    <div className={classes.task}>
      <div ref={animation} className={classes.ticketWrapper}>
        {isEditing ? <>
            <ReactQuill className={classes.ticketContent} theme="snow" defaultValue={description}
                        onChange={setContent} />
            <Box className={classes.buttonsWrapper}>
              <Button className={classes.customButton} onClick={() => setEditTicketId(null)}>
                <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
              </Button>
              <Button className={classes.customButton} onClick={() => saveFunction(id, content)}>
                <FormattedMessage id="button.save" defaultMessage="Save" />
              </Button>
            </Box>
          </>
          : <>
            <div className={classNames(classes.ticketContent, 'view ql-editor')}
                 dangerouslySetInnerHTML={{ __html: description }} />
            {isOpen && <Box className={classes.buttonsWrapper}>
              {isEditVisible(created_at) && <Button className={classes.customButton} onClick={() => enableEdit(id)}>
                <FormattedMessage id="freshdesk.edit.ticket" defaultMessage="Edit ticket" />
              </Button>}
              <Button className={classes.customButton} onClick={() => closeTicket(id)}>
                <FormattedMessage id="freshdesk.close.ticket" defaultMessage="Close ticket" />
              </Button>
            </Box>}
          </>
        }
      </div>
      
      {closePopup && <CloseTicketPopup
        closePopup={closePopup}
        setClosePopup={setClosePopup}
        ticketId={closePopupId}
      />}
    </div>
  );
};

TicketBody.propTypes = {
  ticket: PropTypes.object,
  classes: PropTypes.object,
  updateTicket: PropTypes.func,
};

const decorate = compose(
  connect(store => ({
      user: store.user.profile,
    }),
    dispatch => bindActionCreators({
      updateTicket,
    }, dispatch),
  ),
);

export default decorate(TicketBody);